export default function isValidPhoneNumber(phoneNumber) {
  // Regular expression to validate phone numbers with optional separators
  const phoneRegex = /^(\+?1[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
  
  // Test the phone number against the regex
  return phoneRegex.test(phoneNumber);
}